import { Box, Grid, IconButton, Typography } from '@mui/material';
import MainButton from '../UI/MainButton';
import MenuIcon from '@mui/icons-material/Menu';
import { useContext, useState, useEffect } from 'react';
import { ClickAwayListener } from '@mui/base';
import AuthContext from '../../store/auth-context';
import {
	districtsPage,
	olympicsSettingsPage,
	olympicsStagesPage,
	foreignRegistrationPage,
	registrationPage,
	schoolsPage,
	studentsPage,
	teachersPage,
	emailCampaignsPage,
	managementPage,
	whatsNewPage,
	helpPage,
} from '../../store/fixed-routing';
import { checkVisibleCampaigns } from '../../api/email-campaign-api';
import { getBrandVisualAssets } from '../../config/brand-assets';

type Props = {
	setIndex: (index: number) => void;
};
const PanelMenu = ({ setIndex }: Props) => {
	const brand = getBrandVisualAssets();
	const [open, setOpen] = useState(false);
	const [hasVisibleCampaigns, setHasVisibleCampaigns] = useState(false);
	const { isAdmin, isTeacher, isSecretary, token } = useContext(AuthContext);
	// Versions are now displayed in PanelHeader as watermark

	useEffect(() => {
		if (token && (isTeacher || isSecretary)) {
			checkVisibleCampaigns(token)
				.then((response) => {
					setHasVisibleCampaigns(response.data.has_campaigns);
				})
				.catch(() => {
					setHasVisibleCampaigns(false);
				});
		} else if (isAdmin) {
			setHasVisibleCampaigns(true); // Admin always sees campaigns
		}
	}, [token, isAdmin, isTeacher, isSecretary]);

	return (
		<ClickAwayListener onClickAway={() => setOpen(false)}>
			<Box
				sx={{
					height: { xs: open ? '100%' : 'auto', md: '100%' },
					width: '200px',
					position: 'fixed',
					top: 0,
					left: 0,
					zIndex: 100,
				}}
			>
				<IconButton
					sx={{
						position: 'fixed',
						top: '10px',
						left: '10px',
						display: { xs: open ? 'none' : 'block', md: 'none' },
					}}
					onClick={() => setOpen(true)}
				>
					<MenuIcon />
				</IconButton>
				<Grid
					item
					container
					flexWrap={'nowrap'}
					flexDirection={'column'}
					component={'aside'}
					width={'200px'}
					height={'100%'}
					sx={{
						position: { xs: 'fixed', md: 'relative' },
						top: 0,
						left: 0,
						transition: 'transform .2s',
						transform: { xs: open ? 'none' : 'translateX(-200px)', md: 'none' },
						padding: '10px',
						background: `url(${brand.panelMenuBackground})`,
						backgroundSize: 'cover',
						backgroundPosition: 'center top',
						boxShadow: '10px 0 20px -10px',
						overflow: 'hidden',
						minHeight: 0,
					}}
				>
					{/* Version info */}
					{/* Versions moved to PanelHeader as watermark */}

					<Grid
						item
						container
						justifyContent={'center'}
						rowGap={1}
						sx={{ flexShrink: 0 }}
					>
						{brand.showPatronPortrait && brand.patronPortrait && (
							<Box
								sx={{
									maxWidth: '100%',
								}}
								component={'img'}
								src={brand.patronPortrait}
								alt=''
							/>
						)}
						<Box
							sx={{
								maxWidth: '100%',
							}}
							component={'img'}
							src={brand.logo}
							alt=''
						/>
					</Grid>
					<Grid
						item
						container
						flexDirection={'column'}
						justifyContent={'space-evenly'}
						flexGrow={1}
						sx={{
							width: '100%',
							minHeight: 0,
							// Rozstrzelenie w pionie, ale gap nie „rozpycha” menu poza viewport
							rowGap: 'clamp(4px, 1.2vh, 32px)',
							overflowY: 'auto',
							overflowX: 'hidden',
							py: 0.5,
							WebkitOverflowScrolling: 'touch',
						}}
					>
						<MainButton
							darkVersion={true}
							title={'Okręgi'}
							sx={{ p: 0, flexShrink: 0 }}
							href={districtsPage}
						/>
						<MainButton
							darkVersion={true}
							sx={{ p: 0, flexShrink: 0 }}
							title={'Szkoły'}
							href={schoolsPage}
						/>
						{(isSecretary || isAdmin) && (
							<MainButton
								darkVersion
								sx={{ p: 0, flexShrink: 0 }}
								title={'Nauczyciele'}
								href={teachersPage}
							/>
						)}
						{(isSecretary || isTeacher || isAdmin) && (
							<MainButton
								darkVersion
								sx={{ p: 0, flexShrink: 0 }}
								title={'Uczniowie'}
								href={studentsPage}
							/>
						)}
						{(isSecretary || isAdmin) && (
							<MainButton
								darkVersion
								sx={{ p: 0, flexShrink: 0 }}
								title={'Etapy'}
								href={olympicsStagesPage}
							/>
						)}
						{isAdmin && (
							<MainButton
								darkVersion
								sx={{ p: 0, flexShrink: 0 }}
								title={'Ustawienia'}
								href={olympicsSettingsPage}
							/>
						)}
						{(isAdmin || hasVisibleCampaigns) && (
							<MainButton
								darkVersion
								sx={{ p: 0, flexShrink: 0 }}
								title={'Wysyłki'}
								href={emailCampaignsPage}
								/*onClick={() => setIndex(7)}*/
							/>
						)}
						{isAdmin && (
							<MainButton
								darkVersion
								sx={{ p: 0, flexShrink: 0 }}
								title={'Zarządzanie'}
								href={managementPage}
							/>
						)}
						{isAdmin && (
							<MainButton
								darkVersion
								sx={{ p: 0, flexShrink: 0 }}
								title={'Formularz rejestracji'}
								href={registrationPage}
							/>
						)}
						{isAdmin && (
							<MainButton
								darkVersion
								sx={{ p: 0, flexShrink: 0 }}
								title={'Formularz zagraniczny'}
								href={foreignRegistrationPage}
							/>
						)}
						{(isAdmin || isSecretary || isTeacher) && (
							<MainButton
								darkVersion
								sx={{ p: 0, flexShrink: 0 }}
								title={'Pomoc'}
								href={helpPage}
							/>
						)}
						{(isAdmin || isSecretary || isTeacher) && (
							<MainButton
								darkVersion
								sx={{ p: 0, flexShrink: 0 }}
								title={'Co nowego'}
								href={whatsNewPage}
							/>
						)}
					</Grid>
				</Grid>
			</Box>
		</ClickAwayListener>
	);
};

export default PanelMenu;
